module.exports = __webpack_public_path__ + "img/xici-mini.2a1d6f1c.svg";